<template>
    <div>
        <div style="height:10px;"></div>
        <div class="slider_container">
            <img src="Info2/GreenBg.png">
            <div class="cont_left" id="contLeft" style="opacity: 0.0;">{{thenTxt}}</div>
            <div class="cont_right" id="contRight" style="opacity: 0.0;">{{nowTxt}}</div>
            <div class="slider" id="slider" ref="slider" style="left: 346px; bottom: 5px;">
                <img src="Info2/slider.png">
                <span style="color: #fff;position:absolute; top:0px; left:0px; right:0px; bottom: 0px; text-align: center; vertical-align: middle; line-height: 48px;">{{sliderTxt}}</span>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data: function() {
        return {
            canvas: null
        }
    },
    props : ["ID", "nowTxt", "thenTxt", "sliderTxt"],
    mounted() {
        var slider = this.$refs.slider;

        slider.onmousedown = dragMouseDown;
    },
    methods : {
        
    }
}

function dragMouseDown(e) {
    // console.log("drag down");
    e = e || window.event;
    e.preventDefault();
    // get the mouse cursor position at startup:
    //var pos3 = e.clientX;
    //var pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    // call a function whenever the cursor moves:
    document.onmousemove = elementDrag;
}

function elementDrag(e) {
    // console.log("drag ele");
    // console.log(e);
    e = e || window.event;
    e.preventDefault();

    var xPos = parseInt(e.target.parentNode.style.left) + parseInt(e.movementX);

    if(Number.isNaN(xPos)) return;

    if(xPos < 0) xPos = 0;
    if(xPos > 693) xPos = 693;

    if(xPos < 347) {
        // console.log((xPos.toFixed(1) / 347.0).toString());
        e.target.parentNode.parentNode.getElementsByClassName("cont_right")[0].style.opacity = "0.0";
        e.target.parentNode.parentNode.getElementsByClassName("cont_left")[0].style.opacity = (1.0 - (xPos.toFixed(1) / 347.0)).toString();
    }else {
        var xPosTemp = xPos - 347;
        // console.log(xPosTemp.toFixed(1) / 347.0);
        e.target.parentNode.parentNode.getElementsByClassName("cont_left")[0].style.opacity = "0.0";
        e.target.parentNode.parentNode.getElementsByClassName("cont_right")[0].style.opacity = (xPosTemp.toFixed(1) / 347.0).toString();
    }

    e.target.parentNode.style.left = xPos + "px";
}

function closeDragElement() {
    document.onmouseup = null;
    document.onmousemove = null;
}

</script>
<style scoped>
.slider_container {
    position: relative;
    max-width: 997px;
    max-height:115px;
    height: 115px;
}

.cont_left {
    position: absolute;
    left: 15px;
    top: 15px;
    font-size:14pt;
    color: #fff;
    width: auto;
}

.cont_right {
    position: absolute;
    right: 15px;
    top: 15px;
    font-size:14pt;
    color: #fff;
    width: auto;
}

.slider {
    max-width: 304px;
    width: 304px;
    max-height: 48px;
    height: 48px;
    position: absolute;
    cursor: grab;
}
</style>